// extracted by mini-css-extract-plugin
module.exports = {"container":"U7wZSDbe8DQIdVQXBBj32","os_container":"EoF3OixbZxh8x-1rmLplW"};